<template>
  <div class="planned-transaction-layout-template-block">
    <div class="planned-transaction-layout-template group">
      <div class="text-2sm text-text-ternary">
        {{ $moment(template.date_start, 'YYYY-MM-DD').format('DD.MM.YYYY') }}
      </div>
      <div class="flex items-center">
        <AccountIcon :icon="template.account.icon"
                     :class="{'opacity-50':applyOpacity}"/>
        <AccountName :name="template.account.title"
                     :class="{'opacity-50':applyOpacity}"
                     class="truncate flex-1"/>
      </div>
      <div class="flex items-center truncate">
        <Category v-if="transactionCategory"
                  :category="transactionCategory"
                  :class="{'opacity-50':applyOpacity}"/>
      </div>
      <div class="text-2sm text-text-secondary">
        {{ repeatLabel }}
      </div>
      <div class="justify-self-end flex justify-end">
        <Value :sum="+template.sum"
               class="md:pr-0"
               :class="{'opacity-50':applyOpacity}"
               :currency="template.account.currency"
               :isExpense="template.type === 2 || template.type === 4"
               :type="type"/>
      </div>
      <div class="flex col-gap-4" v-if="!currentUserIsWatcher">
        <IconEdit
            class="transition duration-200 cursor-pointer text-icon hover:text-icon-hover overflow-visible"
            @click.native="$emit('edit')"/>
        <IconTrash
            class="transition duration-200 cursor-pointer text-icon hover:text-icon-hover overflow-visible"
            @click.native="$emit('delete')"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import AccountIcon from "@/components/common/Transaction/TransactionItem/AccountIcon";
import AccountName from "@/components/common/Transaction/TransactionItem/AccountName";
import Category from "@/components/common/Transaction/TransactionItem/Category";
import Value from "@/components/common/Transaction/TransactionItem/Value";
import IconEdit from "@/components/icons/IconEdit";
import IconTrash from "@/components/icons/IconTrash";

export default {
  name: "PlannedTransactionViewTemplate",
  components: {IconTrash, IconEdit, AccountName, AccountIcon, Category, Value},
  props: {
    template: {
      type: Object,
      required: true
    },
    applyOpacity: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher']),
    ...mapGetters('cabinet/constants', ['getConstantList']),
    type() {
      return this.template.type === 1 ? 'income' : 'expense'
    },
    transactionCategory() {
      if (this.template.type === 1) {
        return this.template.income;
      } else {
        return this.template.expense;
      }
    },
    repeatLabel() {
      return this.getConstantList('calendar_repeat').find(type => type.id === this.template.interval).name;
    }
  }
}
</script>

<style lang="scss" scoped>
.planned-transaction-layout-template-block {
  @apply relative;
  &:not(:last-of-type):after {
    @apply bg-border rounded w-full left-0 absolute rounded;
    content: '';
    height: 1px;
    bottom: 1px;
  }
}

.planned-transaction-layout-template {
  @apply grid py-4 items-center col-gap-6 relative;
  grid-template-columns:8.7% 21.8% 24% 19.2% 11% auto;
}

</style>